var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTweetIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:square-top-down-linear",
    clipPath: "url(#clip0_18885_118736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1873 1.33398C11.1873 0.919771 11.5231 0.583984 11.9373 0.583984H15.5C15.9142 0.583984 16.25 0.919771 16.25 1.33398V4.89665C16.25 5.31086 15.9142 5.64665 15.5 5.64665C15.0858 5.64665 14.75 5.31086 14.75 4.89665V3.14464L10.0303 7.86431C9.73744 8.15721 9.26256 8.15721 8.96967 7.86431C8.67678 7.57142 8.67678 7.09655 8.96967 6.80365L13.6893 2.08398H11.9373C11.5231 2.08398 11.1873 1.7482 11.1873 1.33398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27721 2.1993C4.45298 2.31009 4.00039 2.5148 3.67421 2.8404C3.34881 3.16616 3.14408 3.61858 3.03329 4.44297C2.91956 5.28915 2.91797 6.40812 2.91797 8.00065C2.91797 9.59318 2.91956 10.7123 3.03329 11.5585C3.14413 12.3832 3.34893 12.8352 3.67412 13.1601L3.6743 13.1603C4.0001 13.4861 4.4525 13.691 5.27702 13.8019C6.12316 13.9157 7.24209 13.9173 8.83464 13.9173C10.4272 13.9173 11.5463 13.9157 12.3924 13.8019C13.217 13.691 13.669 13.4861 13.9939 13.1607L13.9945 13.1601C14.3201 12.8347 14.525 12.3826 14.6359 11.5582C14.7497 10.7121 14.7513 9.5932 14.7513 8.00065C14.7513 7.58644 15.0871 7.25065 15.5013 7.25065C15.9155 7.25065 16.2513 7.58644 16.2513 8.00065V8.05617C16.2513 9.58037 16.2513 10.8004 16.1225 11.7581C15.9893 12.749 15.7058 13.5706 15.0548 14.2212C14.4045 14.872 13.583 15.1553 12.5924 15.2885C11.6346 15.4174 10.4144 15.4173 8.89016 15.4173H8.77911C7.25491 15.4173 6.03484 15.4174 5.07708 15.2885C4.0862 15.1553 3.26466 14.8719 2.61382 14.2212C1.96301 13.5708 1.67981 12.7491 1.54665 11.7583C1.41794 10.8006 1.41795 9.58036 1.41797 8.05612V7.94519C1.41795 6.42095 1.41794 5.2009 1.54665 4.24317C1.67983 3.25229 1.96301 2.43072 2.61346 1.77984L2.614 1.77929C3.26513 1.12905 4.08652 0.845854 5.07739 0.71267C6.03505 0.583951 7.25493 0.583966 8.77917 0.583985L8.83464 0.583985C9.24885 0.583985 9.58464 0.919772 9.58464 1.33399C9.58464 1.7482 9.24885 2.08399 8.83464 2.08399C7.24211 2.08399 6.1233 2.08558 5.27721 2.1993Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18885_118736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.835938)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTweetIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tweet_icon.b96a8223919e4cbb7440455c3b3c8a6b.svg";